import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { SharedModule } from '@app/shared';
import { CoreModule } from '@app/core';
import { SettingsModule } from './settings';
import { StaticModule } from './static';
import { AppRoutingModule, routingComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { MemberMessagesModule } from './static/member-messages/member-messages.module';
// Loading bar
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// Install language
import { DateAdapter } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import localeSV from '@angular/common/locales/sv';
registerLocaleData(localeSV);
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { SwedishDateAdapter } from './core/adapters/SwedishDateAdapter';
import { FeeTypeService } from './core/services/FeeTypeService';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ChatBotComponent } from '../app/static/chatbot/chatbot.component';

@NgModule({
    imports: [
        // angular
        BrowserAnimationsModule,
        BrowserModule,
        // core & shared
        CoreModule,
        MemberMessagesModule,
        SharedModule,
        // features
        StaticModule,
        SettingsModule,
        // app
        AppRoutingModule,
        // Loading bar
        LoadingBarHttpClientModule,
        // Angular Material
        BrowserModule,
        BrowserAnimationsModule,
        MatAutocompleteModule 
       
    ],
  declarations:
    [
      AppComponent,
      routingComponents,
      ChatBotComponent
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'sv-SE' },
        { provide: LOCALE_ID, useValue: 'sv-SE' },
        { provide: DateAdapter, useClass: SwedishDateAdapter },
        FeeTypeService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

